import { fromEvent } from "rxjs";
import { map } from "rxjs/operators";

interface PwaConfirmEvent extends Event {
  prompt(): void;
  userChoice: Promise<{ outcome: string }>;
}

export const pwaInstaller = fromEvent(window, "beforeinstallprompt").pipe(
  map((e: PwaConfirmEvent) => {
    let installed;

    e.preventDefault();

    return {
      canInstall: () => !installed,
      install: () => {
        e.prompt();

        e.userChoice.then((_) => (installed = true));
      },
    };
  })
);
